'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = require('react-redux');

var _ShareDialog = require('./ShareDialog');

var _ShareDialog2 = _interopRequireDefault(_ShareDialog);

var _feedUserUtil = require('../../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _urls = require('../../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _logValues = require('../../../shared/logging/log-values');

var _adTrackingUtil = require('../../../utils/ad-tracking-util');

var _adTrackingUtil2 = _interopRequireDefault(_adTrackingUtil);

var _actionCreators = require('../../../store/actions/action-creators');

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var showHighlightCta = !!state.sharing.showHighlightCta;
  var notification = state.sharing.notification || {};
  var sharingTitle = state.sharing.title || 'Share This Video';
  var feedItem = state.feedItems && state.feedItems[ownProps.feedContentId] || {};
  var communityContentId = ownProps.communityContentId || {};
  var logData = ownProps.logData,
      onClose = ownProps.onClose;

  var content = feedItem.content;
  var isHighlight = content.item.highlights && content.item.highlights.length;
  var isVideo = content.item.videos && content.item.videos.length;
  var highlight = isHighlight && feedItem.content.item.highlights[0];
  var video = isVideo && feedItem.content.item.videos[0];
  var publicUrl = isHighlight ? _urls2.default.getPublicHighlightUrl(highlight.ownerId.type, highlight.ownerId.relatedId, highlight.reelId, highlight.shortenedUrlId) : 'http://' + document.location.host + '/video/' + (content.hudlContentId && content.hudlContentId.relatedId);

  var title = void 0;
  if (isHighlight) {
    title = highlight.title;
  } else if (content.item.videos && content.item.videos.length) {
    title = content.item.videos[0].title;
  }

  if (!title) {
    var authorId = content.authorId || content.ownerId;
    if (authorId) {
      var author = feedItem.feedUsers.find(function (user) {
        var feedUserId = user.feedUserId;

        return feedUserId.type === authorId.type && feedUserId.relatedId === authorId.relatedId;
      });

      if (author) {
        title = _feedUserUtil2.default.getFeedUserName(author);
      }
    }
  }

  var twitterText = isHighlight && highlight.twitterShareText || isVideo && video.twitterShareText || title && 'Check out ' + title + ' on @Hudl' || '';

  return {
    onClose: onClose,
    title: sharingTitle,
    twitterText: twitterText,
    pageUrl: publicUrl,
    logData: _extends({}, logData, {
      app: _logValues.WEB_APP,
      ownerId: content.ownerId.relatedId,
      ownerType: content.ownerId.type,
      userId: state.userDetails && state.userDetails.userId,
      adTrackingId: _adTrackingUtil2.default.getAdTrackingIdAndSetCookie()
    }),
    communityContentId: communityContentId,
    notification: notification,
    showHighlightCta: showHighlightCta
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    communityContentShared: _actionCreators.communityContentShared
  }, dispatch);
};

var ShareFeedItemContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ShareDialog2.default);

exports.default = ShareFeedItemContainer;